<script>
import Form from '@classes/Form'
import moment from 'moment'
import { authComputed, authMethods, optionsComputed } from '@state/helpers'
import { socialHistoryService } from '@services/SocialHistoryService'
import { healthRecordService } from '@services/HealthRecordService'
import store from '@state/store'
import hrMixin from '@src/mixins/hr-mixin.vue'
export default {
  page: {
    title: 'Social History Editor',
    meta: [{ name: 'description', content: 'The Social History Editor page.' }],
  },
  components: {},
  mixins: [hrMixin],
  props: {
    formDialog: {
      type: Boolean,
      default: false,
    },
    formChanged: {
      type: Boolean,
      default: false,
    },
    formSaved: {
      type: Boolean,
      default: false,
    },
    formSavedAnother: {
      type: Boolean,
      default: false,
    },
    attachmentDeleted: {
      type: Boolean,
      default: false,
    },
    create: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: null,
    },
    id: {
      type: [Number, String],
      default: 0,
    },
    resource: {
      type: String,
      default: 'socialhistory',
    },
    show: {
      type: Boolean,
      default: false,
    },
    unauth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      socialHistoryForm: new Form({
        category: '',
        start_age: '',
        end_age: '',
        specialist_intervention: '',
        frequency: '',
        interval: '',
        note: '',
        private: false,
      }),
      isOngoingHabit: '',
      socialHistoryError: null,
      rules: {
        integerRule: (value) => {
          if (value) {
            if (typeof value === 'string') {
              if (!value.trim()) return true
            }
            if (
              !isNaN(parseInt(value)) &&
              value >= 1 &&
              value <= this.currentAge
            ) {
              return true
            }
            return 'Age between 1 and ' + this.currentAge
          }
          return true
        },
      },
      socialHabits: ['Alcohol', 'Drugs', 'Tobacco', 'Toxin', 'Other'],
      socialHabitsIcons: [
        'mdi-glass-tulip',
        'mdi-cannabis',
        'mdi-smoking',
        'mdi-biohazard',
        'mdi-dots-horizontal',
      ],
      categoryIcon: '',
      attachments: [],
      originalAttachments: [],
      showHRActions: true,
    }
  },
  computed: {
    ...authComputed,
    ...optionsComputed,
    categories() {
      return this.getSocialHistoryOptions?.category
        ? this.getSocialHistoryOptions.category
        : []
    },
    frequencies() {
      return this.getSocialHistoryOptions?.frequency
        ? this.getSocialHistoryOptions.frequency
        : []
    },
    intervals() {
      return this.getSocialHistoryOptions?.interval
        ? this.getSocialHistoryOptions.interval
        : []
    },
    canSaveSocialHistory() {
      if (this.socialHistoryForm.category && this.socialHistoryError === null) {
        return true
      }
      return false
    },
    currentAge() {
      if (this.serializedUser) {
        return moment().diff(this.serializedUser.dob, 'years')
      } else return ''
    },
    startAge: {
      get() {
        return this.socialHistoryForm.start_age
          ? this.socialHistoryForm.start_age
          : 0
      },
      set(value) {
        this.socialHistoryForm.start_age = value
      },
    },
    endAge: {
      get() {
        return this.socialHistoryForm.end_age
          ? this.socialHistoryForm.end_age
          : 0
      },
      set(value) {
        this.socialHistoryForm.end_age = value
      },
    },
    categoryFromIcon: {
      get() {
        return this.categoryIcon
      },
      set(value) {
        if (value !== 'Other') {
          this.socialHistoryForm.category = value
        } else {
          this.socialHistoryForm.category = ''
        }
        this.categoryIcon = value
      },
    },
  },
  watch: {
    socialHistoryForm: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$emit('update:formChanged', true)
        }
      },
      deep: true,
    },
    isOngoingHabit(newVal, oldVal) {
      if (newVal === 'no' && this.socialHistoryForm.end_age === '') {
        this.socialHistoryForm.end_age = this.socialHistoryForm.start_age
      }
      if (
        newVal === 'no' &&
        this.socialHistoryForm.start_age &&
        this.socialHistoryForm.end_age &&
        this.socialHistoryForm.start_age > this.socialHistoryForm.end_age
      ) {
        this.socialHistoryForm.end_age = this.socialHistoryForm.start_age
      }
      if (newVal === 'yes') {
        this.socialHistoryForm.end_age = ''
      }
    },
    'socialHistoryForm.start_age': function (newVal, oldVal) {
      if (this.socialHistoryForm.end_age) {
        if (newVal > this.socialHistoryForm.end_age) {
          this.socialHistoryForm.end_age = newVal
        }
      }
    },
  },
  async mounted() {
    try {
      if (this.edit) {
        if (this.item.patient_id !== null) {
          this.showHRActions = false
        }
        this.itemToForm(this.resource, this.item)
      }

      if (!this.getSocialHistoryOptions) {
        const socialHistoryOptions = (await socialHistoryService.options()).data
        if (socialHistoryOptions) {
          store.dispatch(
            'options/setSocialHistoryOptions',
            socialHistoryOptions
          )
        }
      }
    } catch (error) {
      console.warn(error)
    }
  },
  methods: {
    ...authMethods,
    clearForm() {
      this.categoryFromIcon = ''
      this.socialHistoryForm.reset()
      this.message = false
      this.attachments = []
      this.isAnother = false
      this.isContinue = false
    },
    async getSocialHistoryResponse() {
      if (this.edit) {
        return (
          await healthRecordService.update(
            this.item.hr_id,
            this.socialHistoryForm.removeEmptyStringFromData()
          )
        ).data
      } else {
        return (
          await socialHistoryService.create(
            this.socialHistoryForm.removeEmptyFromData()
          )
        ).data
      }
    },
    async deleteAttachment(id) {
      try {
        const response = await socialHistoryService.attachmentDelete(id)
        if (response) {
          this.originalAttachments = this.originalAttachments.filter(function (
            obj
          ) {
            return obj.id !== id
          })
          this.$emit('update:attachmentDeleted', true)
        }
      } catch (error) {
        console.warn(error)
      }
    },
    setErrors(error) {
      this.socialHistoryForm.onFail(error.response.data)
      if (this.hasResponse) {
        this.message = true
        if (this.formDialog) {
          this.$emit('update:formSaved', true)
        }
      }
      this.socialHistoryError = error
    },
    async tryToSave(action) {
      this.resetFlagsAndErrors('socialHistoryError', action)
      try {
        const response = await this.getSocialHistoryResponse()

        if (response) {
          this.hasResponse = true
          let responseAttachments

          if (this.attachments.length > 0) {
            responseAttachments = (
              await socialHistoryService.attachments(
                this.attachments,
                response.hr_id,
                'socialhistory'
              )
            ).data

            console.warn(responseAttachments)
          }

          await this.fetchWizardData()

          this.message = true
          if (
            action === 'continue' &&
            store.state.calender.addNewRecord === 'true'
          ) {
            this.$emit('update:formSaved', true)
            this.$emit('close-dialog')
            // this.edit ? this.$emit('close-dialog') : this.$emit('back')
            if (document.getElementById('getAllData'))
              document.getElementById('getAllData').click()
          }
          if (action === 'continue') {
            this.$emit('update:formSaved', true)
            this.edit ? this.$emit('close-dialog') : this.$emit('back')
            if (document.getElementById('getAllData'))
              document.getElementById('getAllData').click()
          }
          if (action === 'another') {
            this.$emit('update:formSavedAnother', true)
            this.clearForm()
            this.$emit('add-another')
            if (document.getElementById('updateGetAllData'))
              document.getElementById('updateGetAllData').click()
          }
        }
      } catch (error) {
        console.warn(error)
        this.setErrors(error)
        this.isAnother = false
        this.isContinue = false
        this.scrollToErrors()
      } finally {
        this.tryingToSave = false
      }
    },
    itemToForm(res, item) {
      if (this.socialHabits.indexOf(item.record.category) < 0) {
        this.categoryFromIcon = 'Other'
      } else {
        this.categoryFromIcon = item.record.category
      }
      this.socialHistoryForm.category = item.record.category
      this.socialHistoryForm.start_age = item.record.start_age
      this.socialHistoryForm.end_age = item.record.end_age
      if (this.socialHistoryForm.end_age) {
        this.isOngoingHabit = 'no'
      } else {
        this.isOngoingHabit = 'yes'
      }
      this.socialHistoryForm.specialist_intervention =
        item.record.specialist_intervention
      this.socialHistoryForm.frequency = item.record.frequency?.key
      this.socialHistoryForm.interval = item.record.interval?.key
      if (item.note) {
        this.socialHistoryForm.note = item.note
      }

      this.socialHistoryForm.private = item.private
      this.originalAttachments = item.attachments.map((element) => {
        return { ...element }
      })
    },
    toggleHabbitSelecter(toggle) {
      toggle()
    },
  },
}
</script>

<template>
  <v-container @dragover.prevent @drop="onDrop">
    <v-row
      no-gutters
      :class="$style.hrHeader"
      class="primary--text mt-1"
      justify="center"
    >
      <div class="mr-4">
        <v-img
          :src="
            require('@assets/images/safehaven/health-record-icons/social-habits.svg')
          "
          height="30"
          width="30"
          contain
        ></v-img>
      </div>
      {{ $t('health-record.social-history.form_title') }}
    </v-row>

    <v-row
      :class="$style.hrQuestionFull"
      class="mt-10 offblack--text"
      no-gutters
      justify="center"
    >
      What is this habit related to?
    </v-row>

    <v-row class="mt-10" no-gutters justify="center">
      <v-item-group v-model="categoryFromIcon" class="mb-10">
        <v-row no-gutters>
          <v-col
            v-for="(cat, index) in socialHabits"
            :key="cat + index"
            class="pa-2 d-flex justify-center"
          >
            <v-item v-slot="{ active, toggle }" :value="cat">
              <v-sheet
                class="d-flex align-center clickable"
                :class="[
                  active ? [$style.hrCard, $style.activeCard] : $style.hrCard,
                  show ? $style.disabledClass : '',
                ]"
                width="140"
                height="145"
                flat
                :color="active ? '#EBECFE' : 'background'"
                @click="toggleHabbitSelecter(toggle)"
              >
                <v-card-text>
                  <v-container fluid class="fill-height pa-0">
                    <v-row class="mb-4" justify="center" no-gutters>
                      <v-icon v-show="!active" color="placehold" large>
                        {{ socialHabitsIcons[index] }}
                      </v-icon>
                      <v-img
                        v-show="active"
                        contain
                        max-height="36"
                        max-width="36"
                        :src="require('@assets/images/checkmark.svg')"
                      ></v-img>
                    </v-row>
                    <v-row
                      :class="$style.cardText"
                      justify="center"
                      class="label--text"
                      no-gutters
                    >
                      {{ cat }}</v-row
                    >
                  </v-container>
                </v-card-text>
              </v-sheet>
            </v-item>
          </v-col>
          <v-col
            v-if="!categoryFromIcon && socialHistoryForm.errors.has('category')"
            :class="['error--text', $style.errorText]"
            cols="12"
          >
            Category: {{ socialHistoryForm.errors.get('category') }}
          </v-col>
        </v-row>
      </v-item-group>
    </v-row>

    <div v-if="categoryIcon === 'Other'">
      <v-row class="mt-10" no-gutters justify="center">
        <v-text-field
          v-model="socialHistoryForm.category"
          :disabled="show"
          :placeholder="$t('health-record.social-history.category')"
          :class="$style.hrTextField"
          rounded
          filled
          background-color="input"
          :error-messages="
            socialHistoryForm.errors.has('category')
              ? 'Category: ' + socialHistoryForm.errors.get('category')
              : ''
          "
          @input="
            clearFormFromErrors(
              'category',
              'socialHistoryForm',
              // eslint-disable-next-line vue/comma-dangle
              'socialHistoryError'
            )
          "
        />
      </v-row>
    </div>

    <v-row
      :class="$style.hrQuestion"
      class="mt-7 offblack--text"
      justify="center"
      no-gutters
    >
      At what age do you remember starting this habit?
    </v-row>
    <v-row
      class="mt-10 offblack--text"
      :class="$style.hrQuestionFull"
      no-gutters
      justify="center"
      align="center"
    >
      <v-icon
        :disabled="socialHistoryForm.start_age <= 1 || show"
        color="primary"
        class="mr-7"
        @click="socialHistoryForm.start_age--"
        >mdi-minus-circle-outline</v-icon
      >
      <v-text-field
        v-model="startAge"
        :disabled="show"
        :rules="[rules.integerRule]"
        :class="$style.hrTextFieldSmall"
        rounded
        filled
        hide-details="auto"
        background-color="input"
      >
      </v-text-field>

      <v-icon
        :disabled="socialHistoryForm.start_age >= currentAge || show"
        color="primary"
        class="ml-7"
        @click="socialHistoryForm.start_age++"
        >mdi-plus-circle-outline</v-icon
      >
    </v-row>

    <div v-if="socialHistoryForm.start_age !== ''">
      <v-row class="mt-10">
        <v-col cols="12" md="6">
          <v-row
            :class="$style.hrQuestion"
            class="my-auto offblack--text"
            justify="center"
            no-gutters
          >
            Is this habit still ongoing?
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <v-radio-group
            v-model="isOngoingHabit"
            :disabled="show"
            row
            class="my-auto"
            :class="$style.hrRadio"
          >
            <v-row class="my-auto" justify-md="start" justify="center">
              <v-radio label="No" value="no"></v-radio>
              <v-radio label="Yes" value="yes"></v-radio>
            </v-row>
          </v-radio-group>
        </v-col>
      </v-row>
    </div>

    <div v-if="isOngoingHabit === 'no'">
      <v-row
        :class="$style.hrQuestion"
        class="mt-10 offblack--text"
        justify="center"
        no-gutters
      >
        At what age did you stop?
      </v-row>
      <v-row
        class="mt-10 offblack--text"
        :class="$style.hrQuestionFull"
        no-gutters
        justify="center"
        align="center"
      >
        <v-icon
          :disabled="
            socialHistoryForm.end_age <= socialHistoryForm.start_age || show
          "
          color="primary"
          class="mr-7"
          @click="socialHistoryForm.end_age--"
          >mdi-minus-circle-outline</v-icon
        >
        <v-text-field
          v-model="endAge"
          :disabled="show"
          :rules="[rules.integerRule]"
          :class="$style.hrTextFieldSmall"
          rounded
          filled
          hide-details="auto"
          background-color="input"
        >
        </v-text-field>
        <v-icon
          :disabled="socialHistoryForm.end_age >= currentAge"
          color="primary"
          class="ml-7"
          @click="socialHistoryForm.end_age++"
          >mdi-plus-circle-outline</v-icon
        >
      </v-row>
    </div>

    <v-row
      :class="$style.hrQuestionFull"
      class="mt-10 offblack--text"
      no-gutters
      justify="center"
    >
      What is the frequency of this habit?
    </v-row>

    <v-row class="mt-10">
      <v-col cols="12" md="6">
        <div
          class="mx-auto"
          :class="mobile ? $style.hrInputDivMobile : $style.hrInputDiv"
        >
          <v-select
            v-model="socialHistoryForm.frequency"
            :disabled="show"
            class="socialHistoryFrequency"
            attach=".socialHistoryFrequency"
            :items="frequencies"
            item-text="value"
            item-value="key"
            placeholder="Select Frequency"
            clearable
            rounded
            filled
            background-color="input"
            :class="$style.hrSelect"
            @change="
              clearFormFromErrors(
                'non_field_errors',
                'socialHistoryForm',
                // eslint-disable-next-line vue/comma-dangle
                'socialHistoryError'
              )
            "
          />
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <div
          class="mx-auto"
          :class="mobile ? $style.hrInputDivMobile : $style.hrInputDiv"
        >
          <v-autocomplete
            v-model="socialHistoryForm.interval"
            :disabled="show"
            class="socialHistoryInterval"
            attach=".socialHistoryInterval"
            :items="intervals"
            item-text="value"
            item-value="key"
            placeholder="Select Interval"
            rounded
            clearable
            filled
            background-color="input"
            :class="$style.hrAutoComplete"
            @change="
              clearFormFromErrors(
                'non_field_errors',
                'socialHistoryForm',
                // eslint-disable-next-line vue/comma-dangle
                'socialHistoryError'
              )
            "
          ></v-autocomplete>
        </div>
      </v-col>
    </v-row>

    <v-row class="mt-10">
      <v-col cols="12" md="6">
        <v-row
          :class="$style.hrQuestion"
          class="my-auto offblack--text"
          justify="center"
          no-gutters
        >
          Have you received any help from specialists regarding this habit?
        </v-row>
      </v-col>
      <v-col cols="12" md="6">
        <v-radio-group
          v-model="socialHistoryForm.specialist_intervention"
          :disabled="show"
          row
          class="my-auto"
          :class="$style.hrRadio"
        >
          <v-row class="my-auto" justify-md="start" justify="center">
            <v-radio label="No" :value="false"></v-radio>
            <v-radio label="Yes" :value="true"></v-radio>
          </v-row>
        </v-radio-group>
      </v-col>
    </v-row>

    <v-row class="mt-10">
      <div :class="$style.hrQuestionFull" class="offblack--text"
        >Any additional files or notes you'd like to include?
      </div>
    </v-row>
    <v-row class="mt-10">
      <div class="mx-auto" :class="$style.hrInputDiv">
        <SpeechToText
          :key="'social-history-2'"
          :disabled="show"
          :value.sync="socialHistoryForm.note"
          auto-grow
          rounded
          :class="$style.hrSpeechToText"
          :placeholder="$t('health-record.social-history.note')"
        ></SpeechToText>
      </div>
    </v-row>
    <v-row class="mt-10">
      <div class="mx-auto" :class="$style.hrInputDiv">
        <FileUpload
          :key="'social-history-3'"
          :disabled="show"
          icon
          :height="200"
          :multiple="true"
          :files.sync="attachments"
          :non-draggable="true"
        ></FileUpload>
      </div>
    </v-row>

    <v-row v-if="edit" class="mt-10">
      <div class="mx-auto" :class="$style.hrInputDiv">
        <AttachmentList
          :disabled="show"
          :attachments="originalAttachments"
          @delete-attachment="deleteAttachment"
        ></AttachmentList>
      </div>
    </v-row>

    <ForMyEyesOnly v-if="!show" :value.sync="socialHistoryForm.private" />
    <div v-if="showHRActions">
      <HrActions
        :can-save="canSaveSocialHistory"
        :is-another="isAnother"
        :is-continue="isContinue"
        :trying-to-save="tryingToSave"
        :trying-to-delete="tryingToDelete"
        :edit="edit"
        @go-back="goBack"
        @try-to-save="tryToSave"
        @try-to-delete="prepareDeletion"
      />
    </div>
    <v-row v-if="socialHistoryError" class="ml-1">
      <v-col cols="12" md="12">
        <p class="error--text">{{
          $t('health-record.social-history.error')
        }}</p>
        <div v-if="socialHistoryForm.errors.has('non_field_errors')">
          <div
            v-for="(error, index) in socialHistoryForm.errors.getNonField(
              // eslint-disable-next-line vue/comma-dangle
              'non_field_errors'
            )"
            :key="'error-non-field' + index"
          >
            <p class="error--text">{{ error }}</p>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="message" class="ml-1">
      <p class="success--text">{{
        $t('health-record.social-history.message')
      }}</p>
    </v-row>
    <BaseConfirmDialog
      v-if="confirmDialog"
      :dialog="confirmDialog"
      :message="computedMessage"
      title="Delete Item"
      @cancel="cancel"
      @confirm="deleteItem"
    />
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.disabledClass {
  pointer-events: none;
}
.hrHeader {
  // styleName: Desktop/Display X-Small Bold;
  width: 100%;
  font-family: $system-default-font-family;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  text-align: center;
  letter-spacing: 1px;
}
.hrQuestion {
  // styleName: Desktop/Display X-Small;
  font-family: $system-default-font-family;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
  letter-spacing: 1px;
}
.hrQuestionFull {
  // styleName: Desktop/Display X-Small;
  width: 100%;
  font-family: $system-default-font-family;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
  letter-spacing: 1px;
}
.hrRadio {
  // styleName: Mobile / Display Small;
  font-family: $system-default-font-family;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  text-align: left;
  letter-spacing: 1px;
}
.hrComboBoxContainer {
  width: 394px;
}

.hrComboBox {
  background: $color-theme-light-input;
  border-radius: 15px !important;
}
.hrTextField {
  max-width: 394px !important;
  border-radius: 15px !important;
}
.hrTextFieldCol {
  max-width: 200px !important;
  background: $color-theme-light-input;
  border-radius: 15px !important;
}
.hrAutoComplete {
  max-width: 394px !important;
  border-radius: 15px !important;
}
.hrAutoCompleteCol {
  max-width: 200px !important;
  border-radius: 15px !important;
}
.hrSelect {
  max-width: 394px !important;
  border-radius: 15px !important;
}
.hrInputDiv {
  width: 394px;
  border-radius: 15px !important;
}
.hrInputDivMobile {
  width: 60%;
  border-radius: 15px !important;
}
.hrSpeechToText {
  max-width: 394px !important;
  background: $color-theme-light-input;
}
.cardsContainer {
  padding-right: 120px !important;
  padding-left: 120px !important;
}
.hrCard {
  border-radius: 16px !important;
}
.activeCard {
  border: 1px solid $color-theme-light-secondary !important;
}
.hrButton {
  border-radius: 8px !important;
}
.hrTextFieldSmall {
  max-width: 90px !important;
  font-size: 25px !important;
  border-radius: 15px !important;
}
.hrTextFieldSmall input {
  max-height: 42px !important;
  text-align: center !important;
}
.errorText {
  font-size: 12px;
  color: #ca024f !important;
}
</style>
